import { Button, Chip, Grid, Menu, MenuItem } from "@material-ui/core";
import { Circle, DotsThree, PencilLine, Trash, Triangle } from "phosphor-react";
import React, { useEffect } from "react";
import UsersViewer from "../../../../Utilities/UsersViewer/UsersViewer.jsx";
import useStyles from "./SinglePhaseCard.style.js";
import {
  Checkbox,
  Divider,
  FormControl,
  InputLabel,
  ListItemText,
  OutlinedInput,
  Select,
} from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const SinglePhaseCard = ({
  singlePhase,
  departments,
  handleEditTaskPhaseInfo,
  handleDeleteTaskPhaseInfo,
  serial,
  phases,
  updateNextPhase,
}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [nextFields, setNextFields] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    const updatedNextPhases =
      typeof value === "string" ? value.split(",") : value;

    setNextFields(updatedNextPhases);

    // Update the parent phases array
    updateNextPhase(singlePhase.id, updatedNextPhases);
  };

  useEffect(() => {
    setNextFields(singlePhase?.next_relations || []);
  }, [singlePhase?.next_relations]);

  return (
    <div>
      <div className={classes.singleCardContainer}>
        {/* <div className={classes.flexBetween}>
          <div>{singlePhase?.name}</div>
          <div>Days - {singlePhase?.number_of_days}</div>
          <Button onClick={handleClick}>
            <DotsThree size={25} />
          </Button>
        </div> */}
        <Grid container style={{ alignItems: "center" }}>
          <Grid item xs={4} style={{ textAlign: "start" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div
                style={{
                  padding: "2px 10px",
                  backgroundColor: "#6C65D9",
                  borderRadius: "4px",
                  marginRight: "4px",
                  minWidth: "25px",
                  textAlign: "center",
                }}
              >
                {serial + 1}
              </div>
              <span
                style={{
                  fontWeight: 600,
                  fontSize: "16px",
                }}
              >
                {singlePhase?.name}
              </span>
            </div>
          </Grid>
          <Grid item xs={4} style={{ textAlign: "center" }}>
            {singlePhase?.number_of_days ?? 0} Days{" "}
            {singlePhase?.number_of_hours ?? 0} Hours
          </Grid>
          <Grid item xs={4} style={{ textAlign: "end" }}>
            <Button onClick={handleClick}>
              <DotsThree size={25} />
            </Button>
          </Grid>
        </Grid>
        <Divider
          style={{
            height: "2px",
            margin: "4px 0px 8px 0px",
          }}
        />
        <Grid container>
          <Grid md={4}>
            <span className={classes.description}>
              {singlePhase?.description}
            </span>
          </Grid>
          <Grid
            md={4}
            style={{
              display: "flex",
              // justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <UsersViewer
              assignedUser={singlePhase?.users_to_assign}
              selectedTask={{ assigned_users: singlePhase?.users_to_assign }}
              editable="no"
            />
            <div>{singlePhase?.dept?.name}</div>
          </Grid>
          <Grid
            md={4}
            style={{
              display: "flex",
              justifyContent: "end",
              flexDirection: "column",
            }}
          >
            {/* {departments?.find((dep) => dep.id === singlePhase?.dept)?.name ?? (
              <Chip
                label="Un-configured"
                variant="outlined"
                size="small"
                style={{ color: "orange", borderColor: "orange" }}
              />
            )} */}
            <span style={{ textAlign: "center", color: "gray" }}>
              {" "}
              Next Phase
            </span>
            <FormControl sx={{ m: 1, width: "97%" }}>
              <Select
                placeholder="select next phase"
                labelId="demo-multiple-checkbox-label"
                id="demo-multiple-checkbox"
                multiple
                value={nextFields}
                onChange={handleChange}
                input={<OutlinedInput label="Tag" />}
                renderValue={(selected) =>
                  selected
                    .map((id) => phases.find((phase) => phase.id === id)?.name)
                    .filter(Boolean)
                    .join(", ")
                }
                MenuProps={MenuProps}
                sx={{
                  backgroundColor: "#1B1D28",
                  borderRadius: "10px",
                  padding: "6px 10px",
                  color: "#fff",
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                    borderRadius: "10px",
                  },
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "gray",
                  },
                }}
              >
                {phases
                  ?.filter((sin) => sin?.id !== singlePhase?.id)
                  ?.map((phase) => (
                    <MenuItem
                      key={phase.id}
                      value={phase.id}
                      sx={{
                        backgroundColor: "#1B1D28",
                        color: "#fff !important",
                      }}
                    >
                      <Checkbox
                        checked={phase?.next_relations?.includes(phase.id)}
                        sx={{
                          color: "#fff",
                          "&.Mui-checked": {
                            color: "gray",
                          },
                        }}
                      />
                      <ListItemText
                        primary={phase.name}
                        primaryTypographyProps={{
                          style: { color: "#fff" },
                        }}
                      />
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>
      </div>
      {/*  <div className={classes.customArrow}>
        <Circle className={classes.circle} weight="fill" />
        <div className={classes.line}></div>
        <Triangle className={classes.triangle} weight="fill" />
      </div> */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem
          onClick={() => {
            handleEditTaskPhaseInfo(singlePhase);
            handleClose();
          }}
        >
          <PencilLine size={25} />{" "}
          <span style={{ marginLeft: "10px" }}>Edit Task Phase</span>
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDeleteTaskPhaseInfo(singlePhase);
            handleClose();
          }}
        >
          <Trash size={25} />{" "}
          <span style={{ marginLeft: "10px" }}>Delete Phase</span>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default SinglePhaseCard;
